import * as React from 'react'
import { Link } from 'react-router'

import { cn } from '@/shared/lib/cn'

import { Logo } from './Logo'

export interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
	children?: React.ReactNode
}

export const HeaderTemplate = ({
	children,
	className,
	...props
}: HeaderProps) => {
	return (
		<header
			className={cn('w-full py-1 md:py-4', className)}
			{...props}
		>
			<div className="container flex items-center justify-between">
				<Link to="/">
					<Logo
						slots={{
							base: 'md:gap-1.5',
							logo: 'md:size-6',
							text: 'md:h-6 md:w-[11.25rem]'
						}}
						size="xs"
						withText
					/>
				</Link>
				{children}
			</div>
		</header>
	)
}
